<script>
import NotificationPopup from './NotificationPopup.vue'
import notifChannel from '@/helpers/notif-channel'

export default {
  name: 'NotificationContainer',

  components: {
    NotificationPopup,
  },

  data() {
    return {
      notifications: [],
      notificationGap: 16,
    }
  },

  methods: {
    removeNotification(id, broadcast = true) {
      const index = this.notifications.findIndex(n => n.notification_id === id)
      if (index !== -1) {
        this.notifications.splice(index, 1)

        // kirim ke tab lain
        if (broadcast) {
          notifChannel.postMessage({
            type: 'SYNC_CLOSE_NOTIF',
            id
          })
        }
      }
    },

    addNotification(notification) {
      // ✅ Cek apakah notification_id sudah ada
      const exists = this.notifications.some(
        (n) => n.notification_id === notification.notification_id
      )

      if (exists) {
        console.warn(`⚠️ Notification ${notification.notification_id} already exists, skipping...`)
        return
      }

      this.notifications.push({
        ...notification,
      })

      console.log(`✅ Notification added. Total: ${this.notifications.length}`)
    },

    getTopPosition(id) {
      const BASE_TOP = 20
      let top = BASE_TOP

      for (const n of this.notifications) {
        if (n.notification_id === id) break

        const ref = this.$refs['notif-' + n.notification_id]
        const el = Array.isArray(ref) ? ref[0] : ref

        if (el && el.$el) {
          top += el.$el.offsetHeight + this.notificationGap
        }
      }

      return top
    },

    handleDismiss(notification) {
      this.$emit('dismiss', notification)
    },

    handleViewDetails(notification) {
      this.$emit('view-details', notification)
    },
  },
}
</script>

<template>
  <div class="mc-notification-container">
    <NotificationPopup v-for="notification in notifications" :key="notification.notification_id"
      :ref="'notif-' + notification.notification_id" :notification="notification"
      :duration="notification.duration || 5000" :auto-close="notification.autoClose !== false"
      :style="{ top: getTopPosition(notification.notification_id) + 'px' }"
      @close="removeNotification(notification.notification_id)" @dismiss="handleDismiss"
      @view-details="handleViewDetails" />
  </div>
</template>
